import { css } from 'styled-components';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const ButtonInner = styled.div<{
    isPrimary: boolean;
    isSelected?: boolean;
    isDisabled?: boolean;
    progress?: number;
    isProgressAnimated?: boolean;
}>`
    padding: 8px 16px;
    line-height: 1;
    height: 40px;
    position: relative;
    display: flex !important;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    font-size: 16px;
    border-radius: 4px;
    color: ${(props) =>
        props.isDisabled ? 'var(--color-dark-body-70)' : props.isPrimary ? 'var(--color-light-body)' : 'var(--color-dark-body)'};
    transition: all 0.2s ease-in-out;
    background: ${(props) =>
        props.isDisabled
            ? 'transparent'
            : props.isProgressAnimated
              ? 'var(--color-dark-body-70)'
              : props.isPrimary
                ? 'var(--color-light-background)'
                : props.isSelected
                  ? 'var(--color-dark-body-20)'
                  : 'var(--color-neutral-dark-body-10)'};
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};

    &:not(.no-hover):hover {
        color: ${(props) =>
            props.isDisabled
                ? 'var(--color-dark-body-70)'
                : props.isPrimary
                  ? 'var(--color-light-body)'
                  : props.isSelected
                    ? 'var(--color-dark-body)'
                    : 'var(--color-dark-body)'};
        background: ${(props) =>
            props.isDisabled ? 'transparent' : props.isPrimary ? 'var(--color-light-foreground)' : 'var(--color-dark-body-20)'};
    }

    ${(props) =>
        props.progress &&
        css`
            background: linear-gradient(
                to left,
                var(--color-dark-body-70) ${props.progress}%,
                var(--color-light-background) ${props.progress}%
            );
        `}

    ${(props) =>
        props.progress ||
        (props.isProgressAnimated &&
            css`
                transition: all 0s;
                padding: 14px 18px;
                border: 0;

                &:not(.no-hover):hover {
                    background: var(--color-light-background);
                    border: 0;
                }
            `)}
    
    @media screen and (max-width: 600px) {
        .SVGInline {
            margin: 0 12px 0 0 !important;
        }
    }
`;

export const ProgressAnimation = styled.div.attrs({ className: 'motion-essential' })<{ duration: number }>`
    background: var(--color-light-background);
    height: inherit;
    position: absolute;
    left: 0;
    top: 0;
    width: 0%;
    border: 0;
    border-radius: 4px 0 0 4px;

    animation: progressFullWidth ${(props) => props.duration}s linear;
    animation-fill-mode: forwards;

    & ~ span.label {
        position: relative;
    }
`;

export const ButtonWrapper = styled.button`
    ${buttonReset}
    outline: none;
    text-align: center;
    display: inline-block;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    min-width: 120px;
    z-index: 1;
    padding: 0;
    font-family: ${fontBold};

    &:focus-visible {
        ${ButtonInner} {
            outline: var(--focus-outline);
            transition:
                all 0.2s ease-in-out,
                outline 0.01s linear;
        }
    }
`;
